import { render, staticRenderFns } from "./Birthday-2k24.vue?vue&type=template&id=20c4bab4&scoped=true&"
import script from "./Birthday-2k24.vue?vue&type=script&lang=js&"
export * from "./Birthday-2k24.vue?vue&type=script&lang=js&"
import style0 from "./Birthday-2k24.vue?vue&type=style&index=0&id=20c4bab4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20c4bab4",
  null
  
)

export default component.exports